import dynamic from 'next/dynamic';
import {createTranslator, useTranslations, type AbstractIntlMessages} from 'next-intl';
import withMainLayout from 'layouts/main';
import {pageMessagesProps} from 'helpers/i18n';
import HeroSection from '@/content/industry-technology/hero';
import shared from '../messages/en/shared.json';
import industryTechnology from '../messages/en/industryTechnology.json';

const FeaturesSection = dynamic(
  () => import('@/content/industry-technology/features-section'),
  {loading: () => null}
);
const SplitFeaturesSection = dynamic(
  () => import('@/content/industry-technology/split-features-section'),
  {loading: () => null}
);
const CustomerStoriesSection = dynamic(
  () => import('@/content/industry-technology/customer-stories-section'),
  {loading: () => null}
);
const FaqSection = dynamic(() => import('@/content/industry-technology/faq-section'), {
  loading: () => null
});
const PreFooter = dynamic(() => import('../components/prefooter'), {
  loading: () => null
});

const IndustryTechnologyPage = () => {
  const t = useTranslations('industryTechnology.prefooter');

  return (
    <>
      <HeroSection />
      <FeaturesSection />
      <SplitFeaturesSection />
      <CustomerStoriesSection />
      <FaqSection />
      <PreFooter title={t('title')} subtitle="" />
    </>
  );
};

type PageMessagesProps = {
  locale: string;
  messages: AbstractIntlMessages;
};

const seoMetas = (props: PageMessagesProps) => {
  const t = createTranslator({
    locale: props.locale,
    messages: props.messages
  }) as (key: string) => string;

  return {
    title: t('industryTechnology.seo.title'),
    description: t('industryTechnology.seo.description'),
    canonical: t('industryTechnology.seo.canonical')
  };
};

export const messagesForIntl = {shared, industryTechnology};

export function getStaticProps() {
  return pageMessagesProps(messagesForIntl);
}

export default withMainLayout(IndustryTechnologyPage, seoMetas as never);
